<script>
    export default {
        name: "Loading.vue",
        props: ['loading']
    }
</script>
<template>
    <div>
        <slot v-if="!loading"></slot>
        <div v-if="loading">Loading..</div>
    </div>
</template>
